<template>
  <div class="virtual-account-container" @click.stop>
    <div class="current-type-container" @click="showPaymentSelecter = true">
      <span class="type-category">
        {{ changePriceFormat(curPrice) }} {{ curPayType.show_currency }}
        <span class="get-text" style="margin: 0 5px">=</span>
        <template>
          {{ getProductName(curProduct) }}
          <pay-ico
            :ico="curProduct.PRODUCT_ICON || productDefaultIco"
          ></pay-ico>

          <template v-if="+curProduct.PRODUCT_EXTRA_COIN">
            + {{ curProduct.PRODUCT_EXTRA_COIN }}
            <pay-ico :ico="productExtraCoinIco"></pay-ico>
          </template>
          <template v-if="+curPrice.SUB_COIN">
            + {{ curPrice.SUB_COIN }}<pay-ico :ico="subCoinIco"></pay-ico>
          </template>
          <template v-if="+curPrice.EXTRA_COIN">
            + {{ curPrice.EXTRA_COIN }}<pay-ico :ico="extraCoinIco"></pay-ico>
          </template>
        </template>
      </span>
      <Icon class="selected-type-icon"></Icon>
    </div>
    <PaymentSelecter
      v-if="showPaymentSelecter"
      @closeSelecter="showPaymentSelecter = false"
      :curPayType="curPayType"
      :curProduct="curProduct"
      :curPrice="curPrice"
      :pricesList="pricesList"
      v-bind:showChildSelector="showPaymentSelecter"
      @selectPayMent="selectPayMent"
      style="z-index: 1002"
    ></PaymentSelecter>
  </div>
</template>

<script>
import PaymentSelecter from '@components/officialWebStore/paytype/PaymentSelecter';
import { changePriceFormat } from '@utiles/officialStore';
import PayIco from '@components/officialWebStore/paytype/PayIco.vue';
import { mapGetters } from 'vuex';
import product from '@mixins/product';
import productExtraCoin from '@mixins/officialWebStore/productExtraCoin';
export default {
  name: 'Payment',
  mixins: [product, productExtraCoin],
  props: {
    curPayType: {
      require: true
    },
    languages: {
      require: true
    },
    curProduct: {
      require: true
    },
    pricesList: {
      require: true
    },
    curPrice: {
      require: true
    }
  },
  data() {
    return {
      showPaymentSelecter: false,
      originCoin: 0,
      extraCoin: 0,
      totalCoin: 0
    };
  },
  computed: {
    coinName() {
      return this.$store.state.coinName;
    },
    ...mapGetters([
      'subCoinNama',
      'subCoinIco',
      'extraCoinName',
      'extraCoinIco',
      'coinIco',
      'productDefaultIco'
    ])
  },
  watch: {
    curPrice: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.originCoin = +(newVal?.COIN || 0);
        this.extraCoin = +(newVal?.EXTRA_COIN || 0);
        this.totalCoin = this.originCoin + this.extraCoin;
      }
    }
  },
  methods: {
    changePriceFormat(price) {
      if (price !== undefined) {
        return changePriceFormat(price?.CURRENCY, price?.TRANS_AMOUNT);
      }
      return price && price?.TRANS_AMOUNT;
    },
    selectPrice(price) {
      this.curPrice = price;
      this.$nextTick(() => {
        this.showPaymentSelecter = false;
      });
    },
    selectPayMent(payment) {
      this.$emit('selectPayMent', payment);
      this.showPaymentSelecter = false;
    }
  },
  components: {
    PaymentSelecter,
    PayIco
  }
};
</script>

<style scoped lang="scss">
.ico {
  width: 25px;
  margin: 0px 5px;
}
.type-category {
  display: flex;
  align-items: center;
}
</style>
